/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

export const useTranslateGrade = () => {

  const school = useSelector((state: RootState) => state['user'].school)
  const gradeScale = useSelector((state: RootState) => state['user'].gradeScale)

  return [
    (grade: number) => {

    const map = {
      letters: "sign",
      numbers: "numeric",
      special: "special",
      text: "text"
    }


    if(!school || !school.default_score_type || typeof map[school.default_score_type] === 'undefined' || !gradeScale || gradeScale.length === 0){
      return grade+'%';
    }

    let matchedGrade = gradeScale[0];

    for(let i = 0; i < gradeScale.length; i++)
      if(grade >= gradeScale[i].grade)
         matchedGrade = gradeScale[i];

    return matchedGrade[map[school.default_score_type]];
  },
  (grade: number) => {

    const colors = ['#f03a3a','#e66225','#e6c625','#de31a1','#28cee0','#2c62de','#b5ed6f']

    if(!school || !gradeScale || gradeScale.length === 0)return colors[colors.length - 1];

    let matchedGrade = 0;

    for(let i = 0; i < gradeScale.length; i++)
      if(grade >= gradeScale[i].grade)
         matchedGrade = i;

    if(matchedGrade >= colors.length)
      return colors[colors.length - 1];

    return colors[matchedGrade];
  }
  ]
}
